<template>
  <div class="image-view">
    <div class="head">
      <div class="title">
        <div class="title_content">本地上传</div>
        <div class="close el-icon-close" @click="$emit('imageClose')"></div>
      </div>
      <div class="image_num">
        共{{ imgBase64.length }}张还可以上传{{ 9 - imgBase64.length }}张
      </div>
    </div>
    <div class="view">
      <div class="item" v-for="(item, index) in imgBase64" :key="index">
        <span class="cancel-btn el-icon-close" @click="delImg(index)"></span>
        <img :src="item" />
      </div>
      <div class="addbox" v-show="imgBase64.length < 9">
        <input type="file" @change="getImgBase()" style="cursor: pointer" />
        <div class="addbtn">+</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Update_image",
  data() {
    return {
      imgBase64: [], //存储img base64的值将值传给后端处理
      upimg: [],
    };
  },
  methods: {
    //获取图片base64实现预览
    getImgBase() {
      var _this = this;
      var event = event || window.event;
      var file = event.target.files[0];
      var reader = new FileReader();
      //转base64
      reader.onload = function (e) {
        _this.imgBase64.push(e.target.result);
      };
      this.upimg.push(file);
      reader.readAsDataURL(file);
      this.returnImage();
    },
    //删除图片
    delImg(index) {
      this.imgBase64.splice(index, 1);
      this.upimg.splice(index, 1);
      this.returnImage();
    },
    returnImage() {
      this.$emit("imgArr", this.upimg);
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  height: 5.1875rem;
  width: 100%;
  .title {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .title_content {
      font-size: 0.875rem;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #393939;
    }
    .close {
      margin-top: -0.625rem;
      margin-right: -0.6125rem;
      .el-icon-close:before {
        font-size: 0.875rem;
        color: #696e78;
      }
    }
  }
  .image_num {
    margin-top: 1.25rem;
    font-size: 0.75rem;
    font-family: " Microsoft YaHei";
    font-weight: 400;
    color: #5c5c5c;
  }
}
* {
  /* margin: 0 auto; */
  padding: 0;
  font-family: "微软雅黑";
}
.clearboth::after {
  content: "";
  display: block;
  clear: both;
}
.image-view {
  //   padding: 1.0625rem 1.0625rem 1.375rem;
  width: 100%;
  height: 100%;
  //   margin: 50px auto;
  background-color: #fff;
}
.image-view .addbox {
  float: left;
  position: relative;
  height: 5rem;
  width: 5rem;
  margin-bottom: 1.25rem;
  text-align: center;
}
.image-view .addbox input {
  position: absolute;
  left: 0;
  height: 5rem;
  width: 5rem;
  opacity: 0;
}
.image-view .addbox .addbtn {
  float: left;
  height: 5rem;
  width: 5rem;
  line-height: 5rem;
  color: #fff;
  font-size: 2.5rem;
  background: #ccc;
  //   border-radius: 10px;
  cursor: pointer;
}
.image-view .item {
  position: relative;
  float: left;
  height: 5rem;
  width: 5rem;
  margin: 0.375rem 0.375rem 0 0;
}
.image-view .item .cancel-btn {
  position: absolute;
  right: 0;
  top: 0;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  color: #fff;
  line-height: 1.25rem;
  text-align: center;
  background: red;
  border-radius: 0.625rem;
  cursor: pointer;
}
.image-view .item img {
  width: 100%;
  height: 100%;
}
.image-view .view {
  width: 16.25rem;
  overflow: hidden;
  clear: both;
}
.image-view .addbox .addbtn {
  margin-top: 0.375rem;
}
</style>